<template>
  <router-view />
</template>

<script setup>
import { onMounted } from 'vue'

// 检测是否是移动端
function isMobile() {
  // 方法1: 检测用户代理
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i
  const isMobileByUA = mobileRegex.test(userAgent.toLowerCase())
  
  // 方法2: 检测屏幕宽度
  const isMobileByWidth = window.innerWidth <= 768
  
  return isMobileByUA || isMobileByWidth
}

// 全局移动端检测和跳转
onMounted(() => {
  if (isMobile()) {
    // 如果是移动端，跳转到移动端地址
    window.location.href = 'https://bsh.yw.m.hnzhwlkj.cn/'
  }
})
</script>

<style>
html,body,#app { height: 100%; margin: 0; }
</style>
